// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4t-5";
export var imageContainer = "_4t-4";
export var metricsGrid = "_4t-2";
export var productDetailContainer = "_4t-1";
export var productListContainer = "_4t-0";
export var subscriberTableContainer = "_4t-3";